import { render, staticRenderFns } from "./VDropdownItem.vue?vue&type=template&id=57936ac7&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57936ac7')) {
      api.createRecord('57936ac7', component.options)
    } else {
      api.reload('57936ac7', component.options)
    }
    module.hot.accept("./VDropdownItem.vue?vue&type=template&id=57936ac7&", function () {
      api.rerender('57936ac7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/dropdown/VDropdownItem.vue"
export default component.exports